/**
 * Hogarmola v5 · comportamiento de la portada (funciona también con «reducir movimiento»).
 *
 * 1. «Un problema menos» [data-hm-spec]: la lista de molestias funciona como pestañas. Al elegir
 *    una (clic, teclado o, con ratón, al pasar por encima) cambian el invento, el color de la
 *    baldosa, la frase, el precio y el botón. Mientras nadie la toque y se vea en pantalla, pasa
 *    sola a la siguiente cada 5 segundos (no con «reducir movimiento», ni en el editor de temas,
 *    ni con la pestaña oculta). Sin este script, cada molestia es un enlace a su producto.
 * 2. «Producto en círculo» [data-hm-disco]: cada rasgo cambia la foto del círculo y su dato.
 * 3. «Escena fija» [data-hm-escena]: unos marcadores invisibles de 70vh dicen qué frase toca
 *    según el scroll (IntersectionObserver) y se encienden esa frase y su par de fotos.
 * Se vuelve a montar cuando el editor de temas recarga una sección.
 */
(function () {
  'use strict';

  if (window.hogarmolaV5) return;

  var root = document.documentElement;
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fineQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  var wideQuery = window.matchMedia('(min-width: 990px)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function all(scope, selector) {
    return Array.prototype.slice.call(scope.querySelectorAll(selector));
  }

  function toggle(list, index) {
    list.forEach(function (el, i) {
      el.classList.toggle('is-active', i === index);
    });
  }

  /* ---------------- 1. Un problema menos ---------------- */
  function specimen(section) {
    if (section.hmReady) return;
    section.hmReady = true;

    var list = section.querySelector('[data-hm-spec-list]');
    var names = all(section, '[data-hm-spec-name]');
    var tile = section.querySelector('[data-hm-spec-tile]');
    var objs = tile ? all(tile, '.hm-spec5__obj') : [];
    var facts = all(section, '[data-hm-spec-fact]');
    var factsWrap = facts.length ? facts[0].parentNode : null;
    if (!list || names.length < 2) return;

    var current = 0;
    var touched = false;
    var visible = false;
    var timer = null;

    list.setAttribute('role', 'tablist');
    if (factsWrap) {
      factsWrap.id = factsWrap.id || 'HmSpecFacts-' + Math.random().toString(36).slice(2, 8);
      factsWrap.setAttribute('role', 'tabpanel');
    }

    function orient() {
      list.setAttribute('aria-orientation', wideQuery.matches ? 'vertical' : 'horizontal');
    }
    orient();

    function select(i, focus) {
      if (i < 0) i = names.length - 1;
      if (i >= names.length) i = 0;
      current = i;
      names.forEach(function (name, k) {
        var on = k === i;
        name.classList.toggle('is-active', on);
        name.setAttribute('aria-selected', on ? 'true' : 'false');
        name.setAttribute('tabindex', on ? '0' : '-1');
        name.setAttribute('data-d', String(Math.min(Math.abs(k - i), 3)));
      });
      toggle(objs, i);
      facts.forEach(function (fact, k) {
        var on = k === i;
        fact.classList.toggle('is-active', on);
        if (on) fact.removeAttribute('inert');
        else fact.setAttribute('inert', '');
      });
      if (factsWrap) factsWrap.setAttribute('aria-labelledby', names[i].id);
      var colour = names[i].getAttribute('data-tile');
      if (colour) section.style.setProperty('--tile', colour);
      if (tile) tile.setAttribute('href', names[i].getAttribute('data-url'));

      // En móvil la lista va en fila: centrar la elegida sin mover la página
      if (!wideQuery.matches && list.scrollWidth > list.clientWidth) {
        var target = names[i].offsetLeft - (list.clientWidth - names[i].offsetWidth) / 2;
        list.scrollTo({ left: target, behavior: reduceQuery.matches ? 'auto' : 'smooth' });
      }
      if (focus) names[i].focus();
    }

    function stop() {
      touched = true;
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function tick() {
      if (touched || !visible || document.hidden) return;
      select(current + 1);
    }

    function startAuto() {
      if (timer || touched || designMode || reduceQuery.matches) return;
      timer = window.setInterval(tick, 5200);
    }

    names.forEach(function (name, i) {
      name.setAttribute('role', 'tab');
      if (factsWrap) name.setAttribute('aria-controls', factsWrap.id);
      name.addEventListener('click', function (event) {
        event.preventDefault();
        stop();
        select(i);
      });
      name.addEventListener('pointerenter', function () {
        if (!fineQuery.matches) return;
        stop();
        select(i);
      });
      name.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'ArrowDown' || key === 'ArrowRight') {
          event.preventDefault();
          stop();
          select(current + 1, true);
        } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
          event.preventDefault();
          stop();
          select(current - 1, true);
        } else if (key === 'Home') {
          event.preventDefault();
          stop();
          select(0, true);
        } else if (key === 'End') {
          event.preventDefault();
          stop();
          select(names.length - 1, true);
        } else if (key === 'Enter') {
          // Intro sobre la molestia elegida lleva a su producto
          window.location.href = name.getAttribute('data-url');
        }
      });
    });
    section.addEventListener('focusin', stop);
    section.addEventListener('touchstart', stop, { passive: true });

    select(0);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) startAuto();
        },
        { threshold: 0.35 }
      ).observe(section);
    }

    if (wideQuery.addEventListener) {
      wideQuery.addEventListener('change', function () {
        orient();
        select(current);
      });
    }
    if (reduceQuery.addEventListener) {
      reduceQuery.addEventListener('change', function () {
        if (reduceQuery.matches) stop();
      });
    }
  }

  /* ---------------- 2. Producto en círculo ---------------- */
  function disco(section) {
    if (section.hmReady) return;
    section.hmReady = true;

    var names = all(section, '[data-hm-disco-name]');
    var imgs = all(section, '.hm-disco5__img');
    var facts = all(section, '[data-hm-disco-fact]');
    if (names.length < 2) return;

    function select(i) {
      names.forEach(function (name, k) {
        name.classList.toggle('is-active', k === i);
        name.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      toggle(imgs, i);
      toggle(facts, i);
    }

    names.forEach(function (name, i) {
      name.addEventListener('click', function () {
        select(i);
      });
      name.addEventListener('pointerenter', function () {
        if (fineQuery.matches) select(i);
      });
    });
  }

  /* ---------------- 3. Escena fija ---------------- */
  function escena(section) {
    if (section.hmReady) return;
    section.hmReady = true;

    var lines = all(section, '[data-hm-esc-line]');
    var pics = all(section, '[data-hm-esc-pic]');
    var markers = all(section, '[data-hm-esc-marker]');
    if (!markers.length || !('IntersectionObserver' in window)) return;

    var current = -1;
    function show(i) {
      if (i === current) return;
      current = i;
      toggle(lines, i);
      pics.forEach(function (pic) {
        pic.classList.toggle('is-active', parseInt(pic.getAttribute('data-hm-esc-pic'), 10) === i);
      });
      section.setAttribute('data-step', String(i));
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) show(parseInt(entry.target.getAttribute('data-hm-esc-marker'), 10) || 0);
        });
      },
      { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
    );
    markers.forEach(function (m) {
      observer.observe(m);
    });
    show(0);
  }

  function setup(scope) {
    all(scope, '[data-hm-spec]').forEach(specimen);
    all(scope, '[data-hm-disco]').forEach(disco);
    all(scope, '[data-hm-escena]').forEach(escena);
  }

  root.classList.add('hm-v5-js');
  window.hogarmolaV5 = { setup: setup };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
